export type TimeZone = {
   label: string
   value: string
}

export const timeZones: TimeZone[] = [
   {
      value: 'America/New_York',
      label: 'Eastern Time (ET)',
   },
   {
      value: 'America/Chicago',
      label: 'Central Time (CT)',
   },
   {
      value: 'America/Denver',
      label: 'Mountain Time (MT)',
   },
   {
      value: 'America/Los_Angeles',
      label: 'Pacific Time (PT)',
   },
   {
      value: 'America/Anchorage',
      label: 'Alaska Time (AKT)',
   },
   {
      value: 'America/Phoenix',
      label: 'Mountain Time (Arizona) (MT)',
   },
   {
      value: 'America/Adak',
      label: 'Hawaii-Aleutian Time (HAT)',
   },
   {
      value: 'Pacific/Honolulu',
      label: 'Hawaii Time (HT)',
   },
]
